import { formatAbsoluteDate, formatAbsoluteTime, formatRelativeTime } from '@platewell/core';

/**
 * "3 days ago", with the exact date on hover.
 *
 * `<time dateTime>` carries the machine-readable value alongside the tooltip, so the
 * precise instant is available to anything reading the page rather than only to a mouse.
 */
export function RelativeTime({ value, never = 'Never' }: { value: number | null; never?: string }) {
  if (value == null) return <span className="hint">{never}</span>;
  return (
    <time
      className="data-table-num"
      dateTime={new Date(value).toISOString()}
      title={formatAbsoluteTime(value)}
    >
      {formatRelativeTime(value)}
    </time>
  );
}

/**
 * The calendar date itself, with the time of day on hover.
 *
 * Use this where the date is the fact being reported ("Member since"); use RelativeTime
 * where how long ago it was is the point.
 */
export function AbsoluteDate({
  value,
  never = 'Unknown',
}: {
  value: number | null;
  never?: string;
}) {
  if (value == null) return <span className="hint">{never}</span>;
  return (
    <time
      className="data-table-num"
      dateTime={new Date(value).toISOString()}
      title={formatAbsoluteTime(value)}
    >
      {formatAbsoluteDate(value)}
    </time>
  );
}
